<ci-text-button
  class-name="ci-text-btn-primary-s"
  class="register-user-form__prev-button"
  (click)="goToPrevSlide()"
  [disabled]="!canGoPrev()"
>
  {{ 'Volver' | translate }}
</ci-text-button>

<ci-button
  [class-name]="canGoNext() ? 'ci-btn-primary-s-filled' : 'ci-btn-primary-s-disabled'"
  class="register-user-form__next-button"
  [disabled]="!canGoNext()"
  (click)="isLastSlide() ? handleLastSlideClick() : goToNextSlide()"
>
  {{ 'Continuar' | translate }}
</ci-button>